import React, { useContext, useEffect, useRef, useState } from 'react'
import PageTitle from '../../Utility/PageTitle'
import AgencyForm from './AgencyForm'
import { Card, Steps, Form, Button, Skeleton, Input, InputNumber, message, Modal } from 'antd'
import CandidateForm from './CandidateForm';
import { AuthContext } from '../../Context/AuthContext';
import CandidateFormNew from './CandidateFormNew';
import { useLocation } from 'react-router-dom';
import { useFetch } from '../../../services/ApiService';


function User() {

    const [current, setCurrent] = useState(0);
    const location = useLocation();
    const auth = useContext(AuthContext);
    const [candidateForm, setCandidateForm] = useState(false);
    const [finalPayload, setFinalPayload] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [applicationData, setApplicationData] = useState([]);
    const [loading, setLoading] = useState(false);
    const { fetchApi } = useFetch();

    const onChange = (value) => {
        setCurrent(value);
    };




    const getApplication = async (id) => {
        setLoading(true);
        await fetchApi(`/api/application?id=${id}`, 'GET').then(res => {
            setApplicationData(res);
        }).catch(err => {
            console.log(err);
        })
        setLoading(false);
    }

    useEffect(() => {


        /* if (location.pathname.split('/')[3] !== undefined && location.pathname.split('/')[2] === 'edit') {
            setEditMode(true);
            getApplication(location.pathname.split('/')[3]);
            setCandidateForm(true);
        } */
    }, [])

    const [candidateAadhar, setCandidateAadhar] = useState(null);

    const [aadharLoading, setAadharLoading] = useState(false);
    const handleVerifyAadhar = async ({ aadhar_number }) => {
        /* console.log(values);
        return */
        setAadharLoading(true);
        await fetchApi(`/api/verify_candidate`, 'POST', { aadhar_number }).then(res => {
            console.log(res)
            // setApplicationData(res);
            if (!res.verify_candidate) {
                getCandidateData(aadhar_number);
            }
            else {
                message.error('Aadhar Number is Blacklisted!')
            }

        }).catch(err => {
            console.log(err);
        }).finally(() => {
            setAadharLoading(false);
        })
    }

    async function getCandidateData(aadhar_number) {

        setAadharLoading(true);
        await fetchApi(`/api/application?aadhar_number=${aadhar_number}`, 'GET').then(async res => {
            if (res.length > 0) {
                if (res[0].status === 'pending') {
                    await new Promise((resolve) => {
                        Modal.confirm({
                            title: 'An application is already in process',
                            content: 'An Application with this Aadhar Number is already in process. Please check the status on My Applications page.',
                            onOk: () => {
                                setAadharLoading(false);
                                setCandidateForm(false);
                                return
                            },
                            okText: 'Close',
                            onCancel: false,
                            cancelButtonProps: { style: { display: 'none' } }
                        })
                    })
                }
                else {
                    await new Promise((resolve) => {
                        Modal.confirm({
                            title: 'Aadhaar Number Already Exists',
                            content: 'This Aadhaar number is already registered in our system. Would you like to reapply using this number or enter a different Aadhaar number?',
                            onOk: () => {
                                setApplicationData(res);
                                setCandidateForm(true);
                                setEditMode(true)
                                setCandidateAadhar(aadhar_number);
                                resolve();
                            },
                            okText: 'Re-Apply',
                            onCancel: () => {
                                setCandidateForm(false);
                                setAadharLoading(false);
                                return
                            }
                        })
                    })
                }
            }
            else{
                setCandidateAadhar(aadhar_number);
            }

            setCandidateForm(true);
        }).catch(err => {
            console.log(err);
        }).finally(() => {
            setAadharLoading(false);
        })
    }

    return (
        <>
            <PageTitle title="New Application" />


            <Card>
                {
                    candidateAadhar == null ?
                        <div className='py-4 my-3'>
                            <div className="text-center mb-4">
                                <div className="h3 fw-semibold">Create new Application</div>
                                <div className="h6 fw-normal">Enter aadhar number to proceed.</div>
                            </div>

                            <div>
                                <Form
                                    layout='vertical'
                                    onFinish={handleVerifyAadhar}
                                >
                                    <div className="d-flex gap-4 justify-content-center">
                                        <Form.Item
                                            className='mb-0'
                                            label="Aadhar No."
                                            name="aadhar_number"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Aadhar Number is required',
                                                },

                                            ]}
                                        >
                                            <InputNumber
                                                minLength={12}
                                                maxLength={12}
                                                placeholder='Enter Aadhar Number'
                                                controls={false}
                                                style={{
                                                    width: 300
                                                }}
                                            />
                                        </Form.Item>

                                        <div className="d-flex justify-content-end mt-4 pt-2">
                                            <Button size='large' loading={aadharLoading} type='primary' htmlType='submit'>Next</Button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div> :
                        <>
                            <Steps
                                className='mb-5'
                                current={current}
                                onChange={onChange}
                                items={[
                                    {
                                        title: 'Contract Details',
                                    },
                                    {
                                        title: 'Candidate Details',
                                        disabled: finalPayload.agency_po_numer !== undefined ? false : true
                                    },
                                ]}
                            />



                            <div style={current === 0 ? { display: 'block' } : { display: 'none' }}>
                                <AgencyForm agency_name={auth.currentUser?.agency_name} finalPayload={finalPayload} setFinalPayload={setFinalPayload} setCurrent={setCurrent} editMode={editMode} applicationData={applicationData} loading={loading} />
                            </div>

                            <div style={current === 1 ? { display: 'block' } : { display: 'none' }}>
                                <Skeleton loading={loading}>
                                    <CandidateFormNew
                                        candidateForm={candidateForm}
                                        setCandidateForm={setCandidateForm}
                                        finalPayload={finalPayload}
                                        setFinalPayload={setFinalPayload}
                                        setCurrent={setCurrent}
                                        agency_id={auth.currentUser?.id}
                                        editMode={editMode}
                                        applicationData={applicationData}
                                        appLoading={loading}
                                        candidateAadhar={candidateAadhar}
                                        
                                    />
                                </Skeleton>
                            </div>
                        </>
                }

            </Card>
        </>
    )
}

export default User